import { useEffect, useState } from 'react';

function Index() {
  const [data, setData] = useState();
  const fetchQuestion = async (questionId : number) => {
    const response = await fetch(`/api/card/${questionId}/query`, {
      method: 'POST',
      headers: {
        'X-API-Key': 'mb_4+Em+emu7D4u7/MhLvW6JpujYze/uq81PM1PE+UEdPM=',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        parameters: [],
      }),
    });
    return response.json();
  };

  useEffect(() => {
    fetchQuestion(42).then((data) => setData(data)).catch(() => {});
  }, []);
  return (
    <div>Metabase</div>
  );
}

export default Index;
